// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.affiliate-management__content-wrapper {
	background-color: white;
	min-height: calc(100vh - 1px);
	display: flex;
	flex-direction: column;
	padding: 22px 24px 24px 0;
	gap: 18px;
}

.affiliate-management__content-header {
	display: flex;
	align-items: center;
	justify-content: end;
	padding-right: 160px;
	gap: 16px;
}

.affiliate-management__content {
	display: flex;
	flex-direction: column;
	width: 100%;
	gap: 24px;
	padding: 24px;
	background-color: #f2f2f2;
	border-radius: 10px;
}

.affiliate-management__content-title {
	font-size: 20px;
	line-height: 25px;
	font-weight: 500;
	color: #191919;
}

.affiliate-management__content-filters {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 16px;
}

.affiliate-header-block {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 10px;
}

.affiliate-header-title {
	text-transform: uppercase;
	font-weight: 600;
	margin-bottom: 0;
	color: #144074;
}

.no-affiliates-block {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 80px 0;
}

.no-affiliates-text {
	text-transform: uppercase;
	font-weight: 700;
	margin-top: 20px;
	margin-bottom: 10px;
	color: #144074;
}

.no-affiliates-icon {
	color: #144074;
}

.affiliate-button {
	border: 1px solid rgba(28, 111, 209, 0.5);
	color: #1c6fd1;
	background: #f1f9ff;
	padding: 4px 20px;
	font-weight: 400;
	font-size: 16px;
}

.affiliate-input {
	border: 1px solid rgba(28, 111, 209, 0.5);
	width: 100%;
	height: 35px;
	padding: 2px 10px;
}

.affiliate-input-label {
	color: #144074;
	margin-bottom: 5px;
}

.affiliate-select {
	border: 1px solid rgba(28, 111, 209, 0.5);
	width: 100%;
	height: 35px;
	padding: 2px 10px;
}

.code-animation-block {
	position: absolute;
	top: 0;
	right: 0;
	display: none;
}

.code-animation-result {
	position: absolute;
	top: 10px;
	right: 8px;
	display: none;
}

.code-animation-result-error {
	position: absolute;
	top: 9px;
	right: 12px;
	display: none;
}

.lds-dual-ring {
	width: 40px;
	height: 40px;
}

.lds-dual-ring:after {
	content: " ";
	display: block;
	width: 24px;
	height: 24px;
	margin: 8px;
	margin-top: 6px;
	border-radius: 50%;
	border: 6px solid #fff;
	border-color: rgba(28, 111, 209, 0.5) transparent rgba(28, 111, 209, 0.5)
		transparent;
	animation: lds-dual-ring 1.2s linear infinite;
}

@keyframes lds-dual-ring {
	0% {
		transform: rotate(0deg);
	}

	100% {
		transform: rotate(360deg);
	}
}

.not-have-affiliate {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 20px 0px;
}

.affiliate-code-active-table {
	padding: 0 15px;
	display: none;
}

.affiliate-code-error {
	color: rgb(239, 24, 24);
	font-size: 0.8rem;
}

.button-add-affiliate:disabled {
	opacity: 0.6;
}

.affiliate-code-info-block {
	font-weight: 700;
	font-size: 0.8rem;
	color: #232323;
	padding-left: 5px;
}

.change-code-button {
	display: none;
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/Dashboard/AffiliateManagement/AffiliateManagement.css"],"names":[],"mappings":"AAAA;CACC,uBAAuB;CACvB,6BAA6B;CAC7B,aAAa;CACb,sBAAsB;CACtB,yBAAyB;CACzB,SAAS;AACV;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,oBAAoB;CACpB,oBAAoB;CACpB,SAAS;AACV;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,WAAW;CACX,SAAS;CACT,aAAa;CACb,yBAAyB;CACzB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,SAAS;AACV;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;CACzB,gBAAgB;CAChB,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,uBAAuB;CACvB,eAAe;AAChB;;AAEA;CACC,yBAAyB;CACzB,gBAAgB;CAChB,gBAAgB;CAChB,mBAAmB;CACnB,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,yCAAyC;CACzC,cAAc;CACd,mBAAmB;CACnB,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,yCAAyC;CACzC,WAAW;CACX,YAAY;CACZ,iBAAiB;AAClB;;AAEA;CACC,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,yCAAyC;CACzC,WAAW;CACX,YAAY;CACZ,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,QAAQ;CACR,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,UAAU;CACV,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;CACX,aAAa;AACd;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,YAAY;CACZ,cAAc;CACd,WAAW;CACX,YAAY;CACZ,WAAW;CACX,eAAe;CACf,kBAAkB;CAClB,sBAAsB;CACtB;aACY;CACZ,6CAA6C;AAC9C;;AAEA;CACC;EACC,uBAAuB;CACxB;;CAEA;EACC,yBAAyB;CAC1B;AACD;;AAEA;CACC,WAAW;CACX,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,uBAAuB;CACvB,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,aAAa;AACd;;AAEA;CACC,uBAAuB;CACvB,iBAAiB;AAClB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,gBAAgB;CAChB,iBAAiB;CACjB,cAAc;CACd,iBAAiB;AAClB;;AAEA;CACC,aAAa;AACd","sourcesContent":[".affiliate-management__content-wrapper {\n\tbackground-color: white;\n\tmin-height: calc(100vh - 1px);\n\tdisplay: flex;\n\tflex-direction: column;\n\tpadding: 22px 24px 24px 0;\n\tgap: 18px;\n}\n\n.affiliate-management__content-header {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: end;\n\tpadding-right: 160px;\n\tgap: 16px;\n}\n\n.affiliate-management__content {\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 100%;\n\tgap: 24px;\n\tpadding: 24px;\n\tbackground-color: #f2f2f2;\n\tborder-radius: 10px;\n}\n\n.affiliate-management__content-title {\n\tfont-size: 20px;\n\tline-height: 25px;\n\tfont-weight: 500;\n\tcolor: #191919;\n}\n\n.affiliate-management__content-filters {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tgap: 16px;\n}\n\n.affiliate-header-block {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tmargin-bottom: 10px;\n}\n\n.affiliate-header-title {\n\ttext-transform: uppercase;\n\tfont-weight: 600;\n\tmargin-bottom: 0;\n\tcolor: #144074;\n}\n\n.no-affiliates-block {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\tpadding: 80px 0;\n}\n\n.no-affiliates-text {\n\ttext-transform: uppercase;\n\tfont-weight: 700;\n\tmargin-top: 20px;\n\tmargin-bottom: 10px;\n\tcolor: #144074;\n}\n\n.no-affiliates-icon {\n\tcolor: #144074;\n}\n\n.affiliate-button {\n\tborder: 1px solid rgba(28, 111, 209, 0.5);\n\tcolor: #1c6fd1;\n\tbackground: #f1f9ff;\n\tpadding: 4px 20px;\n\tfont-weight: 400;\n\tfont-size: 16px;\n}\n\n.affiliate-input {\n\tborder: 1px solid rgba(28, 111, 209, 0.5);\n\twidth: 100%;\n\theight: 35px;\n\tpadding: 2px 10px;\n}\n\n.affiliate-input-label {\n\tcolor: #144074;\n\tmargin-bottom: 5px;\n}\n\n.affiliate-select {\n\tborder: 1px solid rgba(28, 111, 209, 0.5);\n\twidth: 100%;\n\theight: 35px;\n\tpadding: 2px 10px;\n}\n\n.code-animation-block {\n\tposition: absolute;\n\ttop: 0;\n\tright: 0;\n\tdisplay: none;\n}\n\n.code-animation-result {\n\tposition: absolute;\n\ttop: 10px;\n\tright: 8px;\n\tdisplay: none;\n}\n\n.code-animation-result-error {\n\tposition: absolute;\n\ttop: 9px;\n\tright: 12px;\n\tdisplay: none;\n}\n\n.lds-dual-ring {\n\twidth: 40px;\n\theight: 40px;\n}\n\n.lds-dual-ring:after {\n\tcontent: \" \";\n\tdisplay: block;\n\twidth: 24px;\n\theight: 24px;\n\tmargin: 8px;\n\tmargin-top: 6px;\n\tborder-radius: 50%;\n\tborder: 6px solid #fff;\n\tborder-color: rgba(28, 111, 209, 0.5) transparent rgba(28, 111, 209, 0.5)\n\t\ttransparent;\n\tanimation: lds-dual-ring 1.2s linear infinite;\n}\n\n@keyframes lds-dual-ring {\n\t0% {\n\t\ttransform: rotate(0deg);\n\t}\n\n\t100% {\n\t\ttransform: rotate(360deg);\n\t}\n}\n\n.not-have-affiliate {\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\tpadding: 20px 0px;\n}\n\n.affiliate-code-active-table {\n\tpadding: 0 15px;\n\tdisplay: none;\n}\n\n.affiliate-code-error {\n\tcolor: rgb(239, 24, 24);\n\tfont-size: 0.8rem;\n}\n\n.button-add-affiliate:disabled {\n\topacity: 0.6;\n}\n\n.affiliate-code-info-block {\n\tfont-weight: 700;\n\tfont-size: 0.8rem;\n\tcolor: #232323;\n\tpadding-left: 5px;\n}\n\n.change-code-button {\n\tdisplay: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
